'use client';

import { memo, useState } from 'react';
import { useLocale } from 'next-intl';

function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

const imgLoader = ({ src, width, quality }) => {
  return `${src}?width=${width}&quality=${quality || 90}`;
};

const isInvalidSrc = (value) => {
  if (!value) return true;
  if (typeof value !== 'string') return true;

  const lowered = value?.toLowerCase();

  return (
    lowered === 'null' ||
    lowered === 'undefined' ||
    lowered?.endsWith('/null') ||
    lowered?.endsWith('/undefined') ||
    lowered?.endsWith('/null/') ||
    lowered?.endsWith('/undefined/')
  );
};

const Image = ({
  className,
  src,
  alt,
  width,
  height,
  priority = false,
  fill = false,
  // withShimmer = false,
  loading,
  sizes = [],
  quality = 100,
  ...props
}) => {
  const locale = useLocale();
  const fallbackLogo = `/imgs/logo-${locale}.png`;
  props?.withShimmer ? delete props.withShimmer : null;

  const [finalSrc, setFinalSrc] = useState(
    isInvalidSrc(src) ? fallbackLogo : src
  );

  // Build srcSet if provided
  const deviceSizes = [500, 1024, 1280, 1600];
  const srcSet = sizes?.map(
    (w, idx) => `${imgLoader({ src, width: w, quality })} ${deviceSizes[idx]}w`
  );
  if (sizes?.length) props.srcSet = srcSet?.join();

  return (
    <div
      className={cn(
        'relative inline-block',
        fill ? 'h-full w-full' : '',
        className
      )}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        alt={alt || ''}
        src={finalSrc}
        fetchPriority={priority ? 'high' : 'low'}
        loading={loading || 'lazy'}
        className={className}
        onError={() => setFinalSrc(fallbackLogo)}
        {...{
          ...(height ? { height: height } : {}),
          ...(width ? { width: width } : {}),
          ...props,
        }}
      />
    </div>
  );
};

export default memo(Image);
